import { render } from "./ProdAvailabilityView.vue?vue&type=template&id=42dd01ec&scoped=true"
import script from "./ProdAvailabilityView.vue?vue&type=script&lang=js"
export * from "./ProdAvailabilityView.vue?vue&type=script&lang=js"

import "./ProdAvailabilityView.vue?vue&type=style&index=0&id=42dd01ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dd01ec"]])

export default __exports__